// src/pages/calidad/QuejasClienteCaptura.jsx
import { useState } from 'react';
import api from '../../services/api';

const TIPOS = ['Interna', 'Queja', 'Reclamo'];
const CLASIFICACIONES = ['Inocuidad', 'Calidad', 'Calidad sensorial', 'E-commerce'];

function formularioVacio() {
  return { fecha_queja: '', cliente: '', descripcion: '', tipo: '', clasificacion: '', sku: '' };
}

export default function QuejasClienteCaptura() {
  const [form, setForm] = useState(formularioVacio());
  const [guardando, setGuardando] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  function actualizar(campo, valor) {
    setForm((prev) => ({ ...prev, [campo]: valor }));
  }

  async function handleGuardar() {
    if (!form.fecha_queja || !form.cliente.trim() || !form.descripcion.trim() || !form.tipo || !form.clasificacion) {
      setMensaje({ tipo: 'error', texto: 'Fecha, cliente, descripción, tipo y clasificación son obligatorios.' });
      return;
    }
    try {
      setGuardando(true);
      setMensaje(null);
      await api.post('/api/calidad/quejas-cliente', form);
      setMensaje({ tipo: 'ok', texto: `✓ Queja de ${form.cliente} capturada (${form.clasificacion}).` });
      setForm(formularioVacio());
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: err.response?.data?.error || 'No se pudo guardar la queja.' });
    } finally {
      setGuardando(false);
    }
  }

  return (
    <div style={styles.contenedor} className="contenedor-captura">
      <h1 style={styles.titulo}>Captura de Quejas de Cliente</h1>
      <p style={styles.subtitulo}>Registra cada queja, reclamo o incidencia interna reportada.</p>

      {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}

      <div style={styles.tarjeta}>
        <div className="fila2">
          <div style={styles.grupo}>
            <label style={styles.label}>Fecha de la queja *</label>
            <input type="date" value={form.fecha_queja} onChange={(e) => actualizar('fecha_queja', e.target.value)} style={styles.input} />
          </div>
          <div style={styles.grupo}>
            <label style={styles.label}>Cliente *</label>
            <input type="text" value={form.cliente} onChange={(e) => actualizar('cliente', e.target.value)} style={styles.input} />
          </div>
        </div>

        <div className="fila2">
          <div style={styles.grupo}>
            <label style={styles.label}>Tipo *</label>
            <select value={form.tipo} onChange={(e) => actualizar('tipo', e.target.value)} style={styles.input}>
              <option value="">— Selecciona —</option>
              {TIPOS.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div style={styles.grupo}>
            <label style={styles.label}>Clasificación *</label>
            <select value={form.clasificacion} onChange={(e) => actualizar('clasificacion', e.target.value)} style={styles.input}>
              <option value="">— Selecciona —</option>
              {CLASIFICACIONES.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>

        <div style={styles.grupo}>
          <label style={styles.label}>SKU (Producto Terminado)</label>
          <input type="text" value={form.sku} onChange={(e) => actualizar('sku', e.target.value)} style={styles.input} placeholder="Opcional" />
        </div>

        <div style={styles.grupo}>
          <label style={styles.label}>Descripción *</label>
          <textarea value={form.descripcion} onChange={(e) => actualizar('descripcion', e.target.value)} style={{ ...styles.input, height: '80px', resize: 'vertical' }} />
        </div>

        {form.clasificacion === 'Inocuidad' && (
          <div style={styles.avisoInocuidad}>⚠ Esta queja se marcará como de Inocuidad — afecta directamente el semáforo del KPI del mes.</div>
        )}
      </div>

      <button onClick={handleGuardar} disabled={guardando || !form.fecha_queja || !form.cliente.trim()} style={styles.botonGuardar}>
        {guardando ? 'Guardando...' : 'Capturar queja'}
      </button>
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '620px' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '4px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', marginBottom: '18px' },
  mensaje: { fontSize: '13px', marginBottom: '14px', fontWeight: 600 },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '16px' },
  grupo: { display: 'flex', flexDirection: 'column', gap: '5px' },
  label: { fontSize: '12px', fontWeight: 600, color: '#6E4F80' },
  input: { padding: '8px 10px', fontSize: '13px', border: '1px solid #D6A644', borderRadius: '6px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7', width: '100%', boxSizing: 'border-box' },
  avisoInocuidad: { fontSize: '12px', fontWeight: 600, color: '#B23A48', background: '#FDF3F1', padding: '10px 12px', borderRadius: '8px' },
  botonGuardar: { width: '100%', padding: '12px', fontSize: '14px', fontWeight: 700, color: '#fff', background: '#6A2C75', border: 'none', borderRadius: '8px', cursor: 'pointer' },
};